$(function () {
    $('.sort_js').on('change', function (e) {
        MAO_Sort.applySort($(this).val());
    });
});
